import {Pipe, PipeTransform} from '@angular/core';

/**
 * Return the list of values from an enum
 **/
@Pipe({
    name: 'values'
})
export class ValuesPipe implements PipeTransform {
    transform(value: Object): any {
        if (value) {
            return Object.values(value);
        }
    }
}
